import React from 'react';
import smallBeginningVideo from '../../assets/Drishtikon award new.mov';

const HomeSmallBeginning = () => {
  return (
    <section className="bg-white px-6 py-14 md:px-12">
      <div className="mx-auto grid max-w-6xl items-center gap-12 md:grid-cols-2 md:gap-16">
        <div className="order-2 md:order-1 md:pr-2 lg:pr-4">
          <h2 className="mb-4 text-center text-3xl font-bold text-accent md:text-left md:text-4xl">
            Our Small Beginning
          </h2>
          <div className="space-y-4 text-base leading-relaxed text-gray-600 md:text-lg">
            <p>
              Every great mission begins with a single, courageous step. Our journey
              started with a simple yet profound idea — to honor the unsung women
              around us who face life's toughest battles with quiet dignity and
              undaunted courage.
            </p>
            <p>
              What began as a small gathering to recognize a handful of these brave
              women has grown into the Drishtikon Himmatwaali Mission, reaching out
              to the extraordinary Himmatwaalis whose stories of hope, resilience
              and strength inspire us all.
            </p>
          </div>
        </div>
        <div className="order-1 flex justify-center md:order-2 md:pl-2 lg:pl-4">
          <div className="w-full max-w-[280px] sm:max-w-[300px] md:max-w-[320px] overflow-hidden rounded-3xl bg-black shadow-xl ring-1 ring-black/5">
            <div className="relative aspect-[9/16] w-full">
              <video
                src={smallBeginningVideo}
                className="absolute inset-0 h-full w-full object-cover"
                controls
                playsInline
                preload="metadata"
                loop
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeSmallBeginning;
